import React, { useState, useEffect, useContext } from "react";
import DataTable from 'react-data-table-component';
import { AddActivity } from "./AddActivity";
import './rightDetails.scss';  // Make sure your SCSS has styles for highlighted-row
import { CandidateActivity } from "./CandidateActivity";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import { LuEye } from "react-icons/lu";
import { AuthContext } from "../../context/AuthContext";
import {toast} from "react-toastify";

export const Activity = (reloadData) => {
  let { id } = useParams(); 
  const { candidateIdValue, setCandidateIdValue } = useContext(AuthContext);
  const [candidateDetails, setCandidateDetails] = useState([]);  
  const [selectedJob, setSelectedJob] = useState(null); // Store the first job    
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedJobCode, setSelectedJobCode] = useState(null);
  const [selectedJobCodeFirst, setSelectedJobCodeFirst] = useState(null);
  const [candidateName,setCandidateName]=  useState(null);
  const [highlightedRowId, setHighlightedRowId] = useState(null);
  const [candidateActivities, setCandidateActivities] = useState([]);
    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const showPopup = () => {
      setIsPopupupVisible(true);
  };

  const hidePopup = () => {
      setIsPopupupVisible(false);
  };


    const fetchDetails = async () => {
      try {
        if (!id){
          id=candidateIdValue;
        }
        const response = await candidateApi.getJobsByCandidate(id);
        console.log("API Response:", response?.data); 
        if (response?.data?.length > 0) {
          setCandidateDetails(response.data);
          setSelectedJob(response.data[0]); // Load first row
          setSelectedJobId(response.data[0].jobId);  
          setSelectedJobCodeFirst(response.data[0].jobCode);  
        } 
      } catch (error) {
        toast.error("Error fetching candidate details:", {
          position: "top-right",
          autoClose: 2000,
          
        });
        console.error("Error fetching candidate details:", error);
      }
    };


  useEffect(() => {
    fetchDetails();
  }, [id]);
  const fetchCandidateActivity = async (id,jobId,jobCode) => {
    try {
      setHighlightedRowId(jobId);
      const response = await candidateApi.getCandidateActivityDetails(id,jobId); 
      console.log(response);
      const resultArray = Object.values(response?.data);
      setCandidateActivities(resultArray || []); // Fallback to an empty array
      setSelectedJobId(jobId); 
      setSelectedJobCode(jobCode); 
    } catch (error) {
      toast.error("Error fetching candidate activity:", {
        position: "top-right",
        autoClose: 2000,
      });
      console.error("Error fetching candidate details:", error);
      setCandidateActivities([]); // Handle error case
    }
  }; 
  useEffect(() => {
    if (candidateDetails && candidateDetails.length > 0) {
        const firstJob= candidateDetails[0]; // Get the first candidate
        if (firstJob.jobId) {
          //setCandidateName(firstCandidate.firstName+ ' ' +firstCandidate.lastName)
          fetchCandidateActivity(id,firstJob.jobId); // Call for the first candidate
        }
      }
}, [candidateDetails]);
  const columns = [
    {
      name: 'Vacancy',
      selector: (row) => row.jobTitle || "No Title",
    },
    {
      name: 'Created On',
      selector: (row) => (row.createdAt ? new Date(row.createdAt).toLocaleDateString() : "N/A"),
    },
    {
      name: 'Status',
      width: "125px",
      cell: (row) => (
        <div className="status primary">
          {row.mappingStatus || 'New'}
        </div>
      ),
    },
    {
      name: 'Status Updated On',
      selector: (row) => (row.updatedAt ? new Date(row.updatedAt).toLocaleDateString() : "N/A"),
    }
    ,
         {
                    name: "",
                    width: "50px",
                    button: true,
                    right: true,
                    cell: (row) => (
                        <div className="gridIcons d-flex gap-2" data-tag="allowRowEvents">
                           
                            <button
                                type="button"
                                className="btn plain-btn-primary view-btn primary-color"
                                title="Details"
                                onClick={() => { fetchCandidateActivity(id,row.jobId,row.jobCode);}}        
                            >
                                <LuEye />
                            </button>
        
                        </div>
                    ),
                }
  ];
  // const data = [
  //   {
  //     id: 1,
  //     vacancy: 'Front End Developer',
  //     createdOn: '30-11-24',
  //     updatedOn: '02-12-24'
  //   },
  //   {
  //     id: 2,
  //     vacancy: 'Back End Developer',
  //     createdOn: '01-12-24',
  //     updatedOn: '03-12-24'
  //   },
  // ];


  return (
    <section>
      <div className="d-flex gap-3 align-items-center mb-3">
        <h5>
          Activity Timeline - <em className="fw-light">{selectedJobCode ? selectedJobCode : selectedJobCodeFirst}</em>
        </h5>
        <button type="submit" className="btn btn-primary ms-auto" onClick={showPopup}
        >
          Add Activity
        </button>
      </div>
      <div className="row">
        <div className="col-12 col-md-7">
          <div className='datatable-holder'>
            <DataTable
              columns={columns}
              data={candidateDetails}
              conditionalRowStyles={[
                {
                  when: (row) => row.jobId === highlightedRowId, // Highlight the selected row
                  classNames: ["highlighted-row"],
                },
              ]}
              
            />
          </div>
        </div>
        <div className="col-12 col-md-5">
          {/* <CandidateActivity  activities={candidateActivities||[]}  reloadData={fetchDetails}/> */}
          <CandidateActivity  activities={candidateActivities||[]}  candidateId={id}/>
        </div>
      </div>
       {isPopupupVisible && <AddActivity closePopup={hidePopup} jobId={selectedJobId} reloadData={fetchDetails} 
       jobCode={selectedJobCode ? selectedJobCode : selectedJobCodeFirst}/>}
    </section>
  );
};
